import { supabase } from '../services/supabaseClient';

const BUCKET = 'registration_docs';

// Format URL publik: .../object/public/registration_docs/<path>. Kolom document_url dan
// kemenag_document_url menyimpan URL dengan format ini (N-12 tetap terbuka).
export const extractDocumentPath = (rawUrl) => {
    const cleanUrl = rawUrl.split('?')[0];
    const separator = `/public/${BUCKET}/`;
    const filePath = cleanUrl.includes(separator)
        ? cleanUrl.split(separator)[1]
        : cleanUrl.split('/').pop();
    return decodeURIComponent(filePath);
};

// Membuka dokumen dari bucket privat lewat signed URL (60 detik). Melempar Error bila gagal.
export const openRegistrationDocument = async (rawUrl) => {
    if (!rawUrl) throw new Error('Dokumen belum diunggah.');

    const { data, error } = await supabase.storage
        .from(BUCKET)
        .createSignedUrl(extractDocumentPath(rawUrl), 60);

    if (error) {
        throw new Error('File tidak ditemukan di server. Kemungkinan data lama atau file telah dihapus.');
    }
    window.open(data.signedUrl, '_blank');
};

// Mengunggah satu PDF dan mengembalikan URL publik (format sama dengan kolom lama).
// Nama file dibuat aman: {user_id}_{waktu}_{jenis}.pdf. Jenis: 'akta-sk' atau 'izin-kemenag'.
export const uploadRegistrationDocument = async (userId, file, kind) => {
    const fileName = `${userId}_${Date.now()}_${kind}.pdf`;
    const { error } = await supabase.storage.from(BUCKET).upload(fileName, file);
    if (error) throw new Error(error.message);

    const { data } = supabase.storage.from(BUCKET).getPublicUrl(fileName);
    return data.publicUrl;
};

// Validasi PDF untuk isian opsional: kosong dianggap valid.
export const pdfRules = {
    validate: {
        acceptedFormats: (files) => {
            if (!files || files.length === 0) return true;
            return files[0].type === 'application/pdf' || 'Format harus PDF';
        },
        maxSize: (files) => {
            if (!files || files.length === 0) return true;
            return files[0].size <= 5 * 1024 * 1024 || 'Ukuran maksimal 5MB';
        }
    }
};

export const BADAN_HUKUM_OPTIONS = [
    { id: 'Yayasan', name: 'Yayasan' },
    { id: 'Perkumpulan', name: 'Perkumpulan' },
    { id: 'Lainnya', name: 'Lainnya' },
    { id: 'Belum berbadan hukum', name: 'Belum berbadan hukum' }
];

// Dokumen yang belum ada, untuk penanda "Dokumen belum dilengkapi" (hanya informasi, tidak
// menghalangi persetujuan, tidak tampil di publik):
// - izin Kemenag kosong, atau
// - akta/SK kosong dan badan hukum bukan 'Belum berbadan hukum'.
export const getMissingDocuments = (registration) => {
    const missing = [];
    if (!registration?.document_url && registration?.legal_entity_type !== 'Belum berbadan hukum') {
        missing.push('Akta atau SK badan hukum');
    }
    if (!registration?.kemenag_document_url) {
        missing.push('Izin Kemenag');
    }
    return missing;
};

// Nama bidang usaha dari embed registration_business_types(master_business_types(name, sort_order)),
// urut sesuai daftar.
export const getBusinessTypeNames = (registration) => {
    const rows = registration?.registration_business_types || [];
    return rows
        .map((row) => row.master_business_types)
        .filter(Boolean)
        .sort((a, b) => (a.sort_order ?? 999) - (b.sort_order ?? 999) || a.name.localeCompare(b.name))
        .map((type) => type.name);
};
